import { type BadgeStatus, StatusBadge } from "@/components/ui/status-badge";

/** HTTP status bucket → NOS StatusBadge semantics (2xx success … 5xx error). */
function bucketStatus(status: number): BadgeStatus {
  if (status >= 500) return "failed";
  if (status >= 400) return "pending";
  if (status >= 300) return "info";
  return "completed";
}

/** Blank when the row has no status (e.g. an `app` category event). */
export function LogStatusBadge({ status }: { status: number | null }) {
  if (status == null) return null;
  return <StatusBadge status={bucketStatus(status)}>{status}</StatusBadge>;
}
